import {
  TransportRequestError,
  useTransportMutation,
  useTransportQuery,
  useTransportQueryUtils,
} from "@/transport"

export function useEmailRecipientAllowlistTransport() {
  const settingsQuery = useTransportQuery({
    operation: "getOrganizationSettings",
  })
  const updateSettings = useTransportMutation("updateOrganizationSettings")
  const queryUtils = useTransportQueryUtils()

  return {
    settingsQuery,
    updateSettings,
    isConflictError: (error: unknown) =>
      error instanceof TransportRequestError && error.status === 409,
    invalidateSettings: () =>
      queryUtils.invalidateOperation("getOrganizationSettings"),
  }
}
